import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
type ChipsProps<T extends string> = {
  'aria-label': string;
  options: {
    value: T;
    label: string;
  }[];
  value: T;
  onChange: (value: T) => void;
};
const Chips = t0 => {
  const $ = _c(10);
  const {
    options,
    value,
    onChange,
    "aria-label": ariaLabel
  } = t0;
  let t1;
  if ($[0] !== onChange || $[1] !== options || $[2] !== value) {
    let t2;
    if ($[4] !== onChange || $[5] !== value) {
      t2 = option => {
        const selected = option.value === value;
        return <button key={option.value} type="button" aria-pressed={selected} onClick={() => onChange(option.value)} className={cx("h-8 px-3 border rounded-(--filter-pill-radius) text-label-3 whitespace-nowrap", {
          "border-transparent bg-accent text-quinary": selected,
          "border-tertiary bg-primary text-primary hover:bg-hover-control": !selected
        })}>{option.label}</button>;
      };
      $[4] = onChange;
      $[5] = value;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = options.map(t2);
    $[0] = onChange;
    $[1] = options;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== ariaLabel || $[8] !== t1) {
    t2 = <fieldset aria-label={ariaLabel} className="flex flex-wrap gap-2">{t1}</fieldset>;
    $[7] = ariaLabel;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default Chips;